import { GeneratedForm } from "@components/form/GeneratedForm"

import { useCompositeState } from "@hooks/use-composite-state"

import FormState from "@plugins/form/FormState"
import { ManagedObject, Node } from "@plugins/form/ManagedObject"

import { ScrollArea } from "@ui/scroll-area"

interface AgentRunnerPayloadPanelProps {
    onUpdate: (payload: ManagedObject) => void
}
export function AgentRunnerPayloadPanel({ onUpdate }: Readonly<AgentRunnerPayloadPanelProps>) {
    const playgroundState = useCompositeState(FormState)
    const payload = playgroundState.payload

    const onParamsChanged = (node: Node) => {
        onUpdate(node as ManagedObject)
    }

    return (
        <ScrollArea className="w-full max-h-[350px] overflow-hidden transition-all duration-500 flex-1 p-1">
            <GeneratedForm object={payload} components={{}} onChange={onParamsChanged} />
        </ScrollArea>
    )
}
